import { PrimaryButton } from '@/components/button/button-component';
import Checkbox from '@/components/react-hook-form-inputs/checkbox/checkbox-component';
import Input from '@/components/react-hook-form-inputs/input/input-component';
import { emailRegex, passwordRules } from '@/utils/validations';
import propTypes from 'prop-types';
import { MdLockOutline, MdOutlineEmail } from 'react-icons/md';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const checkboxStyle = { padding: '0 0 26px 0' };

/**
 * Login form
 * @param {object} props - The pr
 * @param {boolean} props.loading - The loading state
 * @returns {JSX.Element}
 */
const LoginForm = ({ loading }) => (
  <Container>
    <Input
      disabled={loading}
      label="Email Address"
      placeholder="Email"
      iconLeft={<MdOutlineEmail size="20px" />}
      name="email"
      registerOptions={{
        validate: (value) => {
          let errorMessage = null;
          emailRegex.forEach((rule) => {
            if (!rule.pattern.test(value)) {
              errorMessage = rule.message;
            }
          });
          return errorMessage || true;
        },
      }}
    />
    <PasswordContainer>
      <Input
        disabled={loading}
        iconLeft={<MdLockOutline size="20px" />}
        label="Password"
        placeholder="Password"
        name="password"
        registerOptions={{
          validate: (value) => {
            let errorMessage = null;
            passwordRules.forEach((rule) => {
              if (!rule.pattern.test(value)) {
                errorMessage = rule.message;
              }
            });
            return errorMessage || true;
          },
        }}
        type="password"
      />
      <PasswordLink to="/forgot-password" disabled={loading}>
        Forgot password
      </PasswordLink>
    </PasswordContainer>
    <Checkbox
      style={checkboxStyle}
      type="checkbox"
      name="keepMeSignedIn"
      label="Keep me signed in for 2 weeks"
    />
    <PrimaryButton
      buttonWidth="100%"
      buttonHeight="48px"
      type="submit"
      title="LOGIN"
      onClick={() => {}}
      loading={loading}
    />
  </Container>
);

LoginForm.propTypes = {
  loading: propTypes.bool,
};

LoginForm.defaultProps = {
  loading: false,
};

const Container = styled.div`
  display: flex;
  min-width: 420px;
  display: flex;
  margin-top: 24px;
  flex-direction: column;
`;

const PasswordContainer = styled.div`
  position: relative;
  flex-direction: row;
  align-items: center;
`;

const PasswordLink = styled(Link)`
  position: absolute;
  right: 30px;
  top: 35px;
  font-weight: 600;
  display: ${(props) => (props.loading ? 'none' : 'block')};
  text-decoration: none;
  font-size: 14px;
  color: ${(props) => props.theme.COLOR_LINK};
`;

export default LoginForm;
